<nav>
  <header class="nav-header">
    <sort-search-filter-header [title]="title" [enableSort]="true" [enableFilter]="true" [enableSearch]="true" [sortOptions]="sortOptions" (onSort)="sortChanged($event)" (onSearch)="searchOrFilter($event)" (onFilter)="searchOrFilter($event)">
    </sort-search-filter-header>
  </header>
  @if (navItems$ | async) {
    <div class="list">
      @for (navItem of navItems; track navItem) {
        <nav-item class="nav-item" (keydown.enter)="navigate(navItem.id)"
          [item]="navItem" [routerLink]="[navItem.id]" routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: false }">
        </nav-item>
      }
    </div>
  } @else {
    <div class="loader-container">
      <static-loader></static-loader>
    </div>
  }
</nav>
